import React, { useEffect, useState } from 'react';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import SideNav from '../../components/dashboard/side-nav/component';
import PaymentForm from './payment-form';
import SavedCards from './saved-payment-cards';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from '@share/utils';
import { IUserCard } from '@share/common-types';
import { IMyProfileState, addUserCard, getUserCards } from '@share/store/slices';
import { Button, Form, Spin } from 'antd';
import { PaymentMethodBase } from '@components';
import { BlueButton } from '@share/components';

const EMPTY_CARD = {
  addressLine: '',
  cvv: '',
  cardNumber: '',
  cardType: null,
  city: '',
  country: 'US',
  state: '',
  expireDate: '',
  holderName: '',
  phone: '',
  zipCode: '',
} as IUserCard;

interface IMapStateToProps {
  myProfileStore: IMyProfileState;
}

interface IMapDispatchToProps {
  addUserCard: (userCard: IUserCard, sucessCallBack: () => void) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps { }

function PaymentDetailsComponent(props: IProps) {
  const dispatch = useDispatch();
  const { myProfileStore, addUserCard } = props;
  const { result, loadingCards } = myProfileStore;
  const { userCards } = result;

  const [card, setCard] = useState({ ...EMPTY_CARD });
  const [key, setKet] = useState(new Date().getTime());

  const [formPayment] = Form.useForm();

  useEffect(() => {
    dispatch(getUserCards());
  }, []);

  const isFormPaymentValid = () => {
    return formPayment?.getFieldsError()?.some((field) => field.errors.length > 0);
  }

  const handleSaveCreditCard = () => {
    formPayment.validateFields()
      .then(() => {
        const isFormInValid = isFormPaymentValid();
        if (!isFormInValid) {
          addUserCard(card, () => {
            setCard({ ...EMPTY_CARD });
            formPayment.resetFields();
            setKet(new Date().getTime());
          });
        }
      })
      .catch();
  }

  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm bg-transparent border">
              <div className="card-header bg-transparent border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-credit-card mx-2"></i><FormattedMessage id="payment.details" />
                </h4>
              </div>

              <Spin spinning={loadingCards}>
                <div className="card-body p-2 p-sm-4">
                  <h5><FormattedMessage id="saved.cards" /></h5>
                  <SavedCards isCheckout={false} />

                  {(!userCards?.length || userCards?.length < 5) ? (
                    <>
                      <div className="card border mt-4">
                        <div className="card-header border-bottom">
                          <h5 className="card-header-title"><FormattedMessage id="add.new.card" /></h5>
                        </div>
                        <div className="card-body">
                          <PaymentForm
                            form={formPayment}
                            key={key}
                            card={card}
                            loading={loadingCards}
                            setCard={setCard}
                            errorsField={null}
                            formRef={null}
                            display={true}
                            isRequired
                            useFormLabel={false}
                            roundBorders={false}
                            fullWidthForm={true}
                            includePhone
                            skipStorage
                            disableInsurance
                          />

                          <div className="col-12">
                            <BlueButton className='btn btn-primary mb-0 mt-4 commonBlueBtn' block size="large" type="primary" onClick={handleSaveCreditCard}>
                                          <FormattedMessage id="add.credit.card" />
                            </BlueButton>
                          </div>
                        </div>
                      </div>
                    </>) :
                    <div><FormattedMessage id="available.cards.limit" /></div>}

                </div>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    myProfileStore: state.myProfileStore,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  addUserCard: (userCard: IUserCard, sucessCallBack: () => void) => {
    dispatch(addUserCard(userCard, sucessCallBack));
  },
});

const ComponentIntl = injectIntl(PaymentDetailsComponent);

export const PaymentDetails = connect(mapStateToProps, mapDispatchToProps)(withRouter(ComponentIntl));